<section
    class="content2-bg-image no-padding cover-background xs-bg-none border-none bg-img-ten header-margin-top-medium"
    data-img-size="(W)1920px X (H)590px" id=""
    style="background: linear-gradient(rgba(0, 0, 0, 0.00784314), rgba(0, 0, 0, 0.00784314)), url(&#39;assets/images/bg-image/bg-home-empresa.jpg&#39;) fixed;">
    <div class="container sm-width-100 sm-no-padding">
        <div
            class="margen-bloque-texto bg-cream width-80 sm-width-60 xs-width-100 content-style1 padding-four md-padding-eight sm-padding-eighteen">
            <h2
                class="title alt-font title-extra-large-2 sm-title-extra-large-2 xs-section-title-large text-brown margin-one-bottom">
                Tropeando</h2>
            <div class="text-medium sm-text-medium text-dark-gray margin-fifteen-bottom">
                <p> Tropeando es una plataforma de comercialización online de ganado. Nacimos con el propósito de
                    conectar a los productores de ganado y permitirles comercializar sus haciendas de manera
                    electrónica.</p>
                <h3
                    class="title alt-font title-large sm-title-extra-large-2 xs-section-title-large text-dark-brown margin-five-bottom">
                    Lo que nos mueve</h3>
                <p>Nos mueve Paraguay, país que se destaca por ser uno de los mayores exportadores de carne en el mundo.
                </p>
                <p>Nos mueve un compromiso con la ganadería y con todos aquellos que apuestan a este rubro.</p>
                <p>Nos mueve la necesidad de innovar, dando mayor eficiencia a la comercialización de ganado.</p>
                <p>Nos mueven nuestros valores: confianza, transparencia y agilidad en los procesos de compra-venta de
                    ganado.</p>
                <h3
                    class="title alt-font title-large sm-title-extra-large-2 xs-section-title-large text-dark-brown margin-five-bottom">
                    Quienes somos</h3>
                <p>Somos una empresa con capital humano de gente de campo al servicio del campo. Desde Tropeando,
                    deseamos convertirnos en los asesores de sus negocios ganaderos.</p>
            </div>
        </div>
    </div>
</section>
<section class="bg-white padding-30px-tb profile-style9 border-none xs-padding-30px-tb" id="">
    <div class="container">
        <div class="row equalize xs-equalize-auto">
            <div class="col-md-3 col-sm-6 col-xs-12 text-center xs-margin-twenty-three-bottom display-table"
                style="height: 359px;">
                <div class="display-table-cell-vertical-middle">
                    <div class="profile-style9-con border-radius-6 bg-white ">
                        <div class="profile-img"><img alt="" class="img-round-150 margin-fifteen-bottom"
                                data-img-size="(W)200px X (H)200px" src="assets/images/carlos/200x200.jpg"></div>
                        <div class="text-medium margin-seven-bottom center-col width-85 sm-width-100">Carlos
                            Huidobro<br>Ing. Agrónomo</div>
                        <div class="text-meduim alt-font text-dark-gray font-weight-600">Socio Director, con experiencia
                            en comercialización y certificación de ganado.</div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-sm-6 col-xs-12 text-center xs-margin-twenty-three-bottom display-table"
                style="height: 359px;">
                <div class="display-table-cell-vertical-middle">
                    <div class="profile-style9-con border-radius-6 bg-white ">
                        <div class="profile-img"><img alt="" class="img-round-150 margin-fifteen-bottom"
                                data-img-size="(W)200px X (H)200px" src="assets/images/ramon/200x200.JPG"></div>
                        <div class="text-medium margin-seven-bottom center-col width-85 sm-width-100">Ramón
                            Huidobro<br>Ing. Agrónomo</div>
                        <div class="text-meduim alt-font text-dark-gray font-weight-600">Socio Director, con experiencia
                            en comercialización y certificación de ganado.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>